// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form {\r\n    padding-top: 5px;\r\n}\r\n\r\n.searchBox {\r\n    justify-content: center;\r\n    display: flex;\r\n}\r\n\r\n.searchBox > div > div > i {\r\n    display: none;\r\n}\r\n\r\n.btn-advanced-search{\r\n    display:none;\r\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
